import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Button, CloseButton, Col, Container, FloatingLabel, Form, Image, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const Post = (props) => {
    async function getCommunityImageInfo(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/info/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getCommunityReply(groupId,replyCommentId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/reply/"+groupId+"/"+replyCommentId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteCommunityReply(groupId,replyCommentId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/reply/"+groupId+"/"+replyCommentId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteCommunityImage(groupId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/user/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // 投稿処理
    function upload(groupId,userId){
        let fapi = new ApiFetch()
        let fd = new FormData()
        fd.append("user_id",userId)
        fd.append("text",document.getElementById("text").value)
        fapi.fileUpload(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/reply/"+groupId,fd).then((r)=>{
            r.json().then(json=>{
                if(json.result){
                    let text = document.getElementById("text")
                    text.value = ""
                    getCommunityReply(groupId,"",1).then(r=>{
                        if(r.result){
                            setCommunityReplyInfo(r.info)
                            setCommunityReplyDetail(r.detail)
                        }
                    })
                } else {
                    dialog("エラー",json.errors.join("\r\n"))
                }
            })
        })
    }
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate();
    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (communityReplyPage * 10 - 1) ){
                    setCommunityReplyPage(communityReplyPage+1)
                    getCommunityReply(groupId,"",communityReplyPage+1).then(r => {
                        if(r.result){
                            setCommunityReplyInfo(r.info)
                            setCommunityReplyDetail(communityReplyDetail.concat(r.detail))
                        }
                    })
                }
              }
        })
    }, options);

    let param = useParams();
    let groupId = param.id;

    // 削除対象選択情報
    const [item, selectItem] = useState('');
    const [deleted, setDeleted] = useState('');

    // 検索情報
    const [page,setPage] = useState(0)
    const [communityReplyPage,setCommunityReplyPage] = useState(1)

    // コミュニティ取得情報
    const [communityImageInfo,setCommunityImageInfo] = useState([])
    const [communityReplyInfo,setCommunityReplyInfo] = useState([])
    const [communityReplyDetail,setCommunityReplyDetail] = useState([])

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // ページ遷移
    useEffect(() =>{
        getCommunityImageInfo(groupId).then(r=>{
            if(r.result){
                setCommunityImageInfo(r)
            } else {
                dialog("エラー",r.errors)
            }
        })
        getCommunityReply(groupId,"",1).then(r=>{
            if(r.result){
                setCommunityReplyInfo(r.info)
                setCommunityReplyDetail(r.detail)
            }
        })
    },[deleted,groupId,page])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[communityImageInfo,communityReplyDetail])

    // 削除ボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            if(item.type === "community"){
                deleteCommunityImage(item.id).then(r=>{
                    if(r.result){
                        setDeleted(item.id)
                    } else {
                        dialog("エラー",r.errors)
                    }
                    setOkButtonShow(false)
                })
            } else if(item.type === "community_reply"){
                deleteCommunityReply(groupId,item.id).then(r=>{
                    if(r.result){
                        setDeleted(item.id)
                    } else {
                        dialog("エラー",r.errors)
                    }
                    setOkButtonShow(false)
                })
            }
        }}>OK</Button>
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        <Header />
        <Category />
        <Container>
            {communityImageInfo.result ? (
                <Container>
                    <div style={{width:"360px",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"20px",marginBottom:"30px"}}>
                        <Row>
                            <Col xs={2}>
                                <Image className="lazy" data-src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+communityImageInfo.info.user_id+"_s.jpg"} style={{width:"50px",height:"50px",borderRadius:"25px",marginRight:"30px",cursor:"pointer"}} onClick={() => navigate("/user/"+communityImageInfo.info.user_id)} />
                            </Col>
                            <Col style={{position:"relative"}}>
                                {(loginInfo.userId === communityImageInfo.info.user_id)? (
                                    <CloseButton style={{position:"absolute",zIndex:"1",top:"0px",right:"20px"}} onClick={()=>{
                                            selectItem({type:"community",id:groupId})
                                            setOkButtonShow(true)
                                            dialog("確認","削除しますか？")
                                    }} />
                                ) : ""}
                                <Container style={{fontSize:"14px",marginBottom:"5px"}}>{communityImageInfo.info.user_name}</Container>
                                <Container style={{whiteSpace: "pre-wrap"}}>{communityImageInfo.info.text}</Container>
                                <Container style={{width:"100%",margin:"auto"}}>
                                    <Image className="lazy" data-src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/community/t/'+(communityImageInfo.detail[0].id)+'.jpg'} style={{objectFit:"contain",width:"100%"}}/>
                                </Container>
                                <Container>
                                    <FavoriteIcon style={{cursor:"pointer"}} type="community" id={groupId} favorite={communityImageInfo.info.favorite} dialog={dialog} />
                                </Container>
                            </Col>
                        </Row>
                    </div>
                </Container>
            ):""
            }
            <Container>
                <div style={{display:"inline-block",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"10px 5px",marginBottom:"10px"}}>
                    <FloatingLabel controlId="text" label="コメントを記載" className='mb-3 w-100' style={{lineHeight:"20px"}} onInput={(e) =>{
                        let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                        let n = e.nativeEvent.target.value.match(/\n/g)
                        if(n === null){
                            n = 1
                        } else {
                            n = n.length + 1
                        }
                        e.currentTarget.style.height = lineHeight * n + 30 + "px"
                        document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                    }}>
                        <Form.Control
                            className='textarea'
                            as="textarea"
                            style={{ width:"350px",height: '50px' }}
                            required
                        />
                    </FloatingLabel>
                    <Container>
                        <Button onClick={() => {
                            let text = document.getElementById("text")
                            if(text.value.trim().length === 0){
                                dialog("エラー","コメントを入力して下さい。")
                                return
                            }
                            if(text.value.trim().length > 2500){
                                dialog("エラー","コメントは2500文字以内にして下さい。")
                                return
                            }
                            upload(groupId,communityImageInfo.info.user_id)
                        }}>投稿</Button>
                    </Container>
                </div>
                <div>
                    {communityReplyDetail && communityReplyDetail.map((comment,i) => {
                        if(i === 10){
                            return ""
                        }
                        return (
                            <div style={{width:"360px",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"10px",marginBottom:"10px"}} key={i}>
                                <Row>
                                    <Col xs={2}>
                                        <Image data-no={i} className="lazy" data-src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+comment.reply_user_id+"_s.jpg"} style={{width:"50px",height:"50px",borderRadius:"25px",marginRight:"30px"}} />
                                    </Col>
                                    <Col style={{position:"relative"}}>
                                        {(loginInfo.userId === comment.reply_user_id || loginInfo.userId === communityReplyInfo.post_user_id) ? (
                                            <CloseButton style={{position:"absolute",zIndex:"1",top:"0px",right:"20px"}} onClick={()=>{
                                                selectItem({type:"community_reply",id:comment.comment_id})
                                                setOkButtonShow(true)
                                                dialog("確認","削除しますか？")
                                            }} />
                                        ):""}
                                        <Container style={{fontSize:"14px",marginBottom:"5px"}}>{comment.user_name}</Container>
                                        <Container style={{whiteSpace: "pre-wrap"}}>{comment.text}</Container>
                                        <Container>
                                            <span style={{fontSize:"14px",color:"#555555"}}>{comment.post_datetime}</span>
                                            <FavoriteIcon style={{cursor:"pointer"}} type="community_reply" id={comment.comment_id} favorite={comment.favorite} dialog={dialog} />
                                            {comment.favorite_count === 0 ? "" : comment.favorite_count}
                                        </Container>
                                    </Col>
                                </Row>
                            </div>
                        )
                    })}
                </div>
            </Container>
        </Container>
        <Footer />
    </div>
    )
}

export default Post;
